export default "__VITE_ASSET__$j$IfQ2q__"